import {Button, CircularProgress, Container} from "@mui/material";
import dayjs from "dayjs";
import {Grid} from "@mui/system";
import React, {useEffect, useRef, useState} from "react";
import OtpInput from "react-otp-input";
import style from "../../assets/css/login-register.module.scss";
import {useNavigate, useParams} from "react-router-dom";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {
  RESEND_OTP,
  VERIFY_EMAIL,
  VERIFY_OTP,
} from "../../constants/apiConstant";
import {useDispatch} from "react-redux";
import {setAuthData} from "../../store/authSlice";
import duration from "dayjs/plugin/duration";
import {setUiData} from "../../store/uiSlice";
import {removeCookies, setCookies} from "../../constants/helper";
import EmailSucces from "../../assets/img/dashboard/mail-s.png";
// Extend day.js with the duration plugin
dayjs.extend(duration);

const AttemptLimit = 3; // Maximum OTP attempts allowed

const Verification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {type, uid} = useParams();
  const [otp, setOtp] = useState("");
  const [enableCounter, setEnableCounter] = useState(false);
  const [counter, setCounter] = useState(180);
  const [verifSuccess, setVerifSuccess] = useState(null);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [attemptsLeft, setAttemptsLeft] = useState(AttemptLimit);

  const handleVerify = async (e) => {
    if (!otp || otp === null || otp === undefined || otp === "") {
      // GlobalNotificationPopup({ type: "info", message: "Please Enter OTP Code." });
      return;
    }

    if (attemptsLeft <= 0) {
      return; // Prevent further verification attempts
    }

    dispatch(
      setUiData({
        showLoader: true,
      })
    );
    let data = {};
    if (type === "otp") {
      data = {otp, user_id: uid};
    } else if (type === "email") {
      data = {otp, user_id: uid};
    }

    const options = {
      method: VERIFY_OTP.method,
      headers: VERIFY_OTP.headers,
      body: JSON.stringify(data),
    };

    fetch(VERIFY_OTP.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          setError(true);
          setAttemptsLeft((prev) => prev - 1);
          GlobalNotificationPopup({
            type: "error",
            message: `${res?.message}. ${attemptsLeft - 1} attempt(s) remaining.`,
          });
          setErrorMsg(
            `Invalid OTP. Only ${attemptsLeft - 1} Attempt(s) Remaining.`
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          if (attemptsLeft - 1 === 0) {
            removeCookies("isLogin");
            setTimeout(() => navigate("/login"), 2000);
          }

          // navigate("/login");
        } else if (res.status == 1) {
          setCookies("isLogin", "true");
          GlobalNotificationPopup({type: "success", message: res?.message});
          dispatch(
            setAuthData({
              user: res?.user,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          setTimeout(() => {
            navigate(`/dashboard`);
          }, 500);
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        console.log("error", error);
        navigate("/");
      });
  };

  const getOTP = async (e) => {
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {user_id: uid};

    const options = {
      method: RESEND_OTP.method,
      headers: RESEND_OTP.headers,
      body: JSON.stringify(data),
    };

    fetch(RESEND_OTP.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          GlobalNotificationPopup({type: "error", message: res?.message});
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          removeCookies("isLogin");
          navigate("/login");
        } else if (res.status == 1) {
          setOtp("");
          // otpInputRef.current.value = '';
          GlobalNotificationPopup({type: "success", message: res?.message});
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          setCounter(180);
          removeCookies("isLogin");
        }
      })
      .catch((error) => {
        setOtp("");
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        console.log("error", error);
        navigate("/");
      });
  };

  const verifyEmail = async (e) => {
    // openModal(true);
    setVerifSuccess(false);
    let data = {user_id: uid};

    const options = {
      method: VERIFY_EMAIL.method,
      headers: VERIFY_EMAIL.headers,
      body: JSON.stringify(data),
    };

    fetch(VERIFY_EMAIL.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          GlobalNotificationPopup({type: "error", message: res?.message});
          removeCookies("isLogin");
          navigate("/login");
        } else if (res.status == 1) {
          setVerifSuccess(true);
          setTimeout(() => {
            navigate(`/login`);
          }, 3500);
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        console.log("error", error);
        navigate("/");
      });
  };

  const firstCall = useRef(false);

  useEffect(() => {
    if (!firstCall.current && type && type === "email") {
      firstCall.current = true;
      verifyEmail();
    } else if (type) {
      setEnableCounter(true);
    }
  }, [type]);

  useEffect(() => {
    if (enableCounter) {
      if (counter === 0) return;
      const intervalId = setInterval(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [counter, enableCounter]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const formattedSeconds = seconds % 60;
    return `${minutes}:${formattedSeconds < 10 ? `0${formattedSeconds}` : formattedSeconds}`;
  };

  return (
    <>
      <div className={style.verificationMainSection}>
        <Container fullWidth>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid size={{xs: 12, lg: 6}}>
              <div className={style.verifyMain}>
                {type !== "email" ? (
                  <>
                    <h1>Verification</h1>
                    <span>
                      OTP code has been sent to registered
                      <br /> Mobile Number & Email Address.
                    </span>
                    <div className={style.otpInputMain}>
                      <OtpInput
                        value={otp}
                        onChange={(e) => {
                          if (error) {
                            setError(false);
                          }
                          setOtp(e);
                        }}
                        onPaste={(e) => {
                          e.preventDefault(); // prevent default paste behavior
                          const pastedData = e.clipboardData
                            .getData("text")
                            .trim();
                          const numericPastedData = pastedData
                            .replace(/\D/g, "")
                            .slice(0, 6); // only allow digits, max 6
                          if (error) {
                            setError(false);
                          }
                          // console.log("PASTED OTP", numericPastedData);
                          setOtp(numericPastedData);
                        }}
                        shouldAutoFocus
                        numInputs={6}
                        inputType="number"
                        renderSeparator=""
                        renderInput={(props) => (
                          <input
                            className={style.otpInputInner}
                            {...props}
                            style={
                              error
                                ? {
                                    ...props.style,
                                    border: "1px solid red", // Spread the default stylesF
                                  }
                                : {
                                    ...props.style,
                                  }
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleVerify();
                              }
                            }}
                            // ref={otpInputRef}
                          />
                        )}
                      />
                    </div>
                    <Button
                      className={style.verifyBtn}
                      fullWidth
                      variant="contained"
                      type="button"
                      onClick={handleVerify}
                      disabled={attemptsLeft === 0}
                    >
                      Verify & Continue
                    </Button>
                    <div className={style.AttemptLeft}>
                      {attemptsLeft !== 0 ? (
                        <span>{errorMsg}</span>
                      ) : (
                        <span>Too many failed attempts. Redirecting...</span>
                      )}
                    </div>
                    <div className={style.ResendOtpCode}>
                      {counter === 0 ? (
                        <u onClick={getOTP}>Get new OTP code</u>
                      ) : (
                        <p>
                          Re-send OTP code in{" "}
                          <strong>{formatTime(counter)}</strong>
                        </p>
                      )}
                    </div>
                  </>
                ) : (
                  <div className={style.EmailVerificationMain}>
                    {verifSuccess === true ? (
                      <>
                        <div className={style.EmailVerification}>
                          <img src={EmailSucces} alt="emailsuccess" />
                        </div>
                        <h2>Email Verified Successfully.</h2>
                      </>
                    ) : verifSuccess === false ? (
                      <>
                        <div className={style.EmailVerificationICon}>
                          <CircularProgress size={80} thickness={1.5} />
                        </div>
                        <h2>Verifying Email...</h2>
                      </>
                    ) : null}
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
      {/* {
        modal ? <GlobalModal handleClose={() => { openModal(false) }} title={"Email Address Verification"} /> : null
      } */}
    </>
  );
};

export default Verification;
